import {useTranslation} from 'react-i18next';

import {Box, Grid, Typography} from '@mui/material';

import {bodyPdf, pdfH1} from '../styles';

import {orangeColors, empionOrangeGradient} from '../../../../layouts/theme/designSystem';

interface Props {
  pageTitle: string;
  pageSection?: string;
  totalOverlap: number;
}

export const AppendixHeader = ({pageTitle, totalOverlap, pageSection}: Props) => {
  const {t} = useTranslation('pdfDomain');
  const replaceColon = (str: string) => str.replace(/:/g, '.');

  return (
    <Grid container sx={{background: empionOrangeGradient.dark}} height={'180px'} p={5}>
      <Typography variant='h1' sx={pdfH1}>
        {t(pageTitle)}
      </Typography>
      {pageSection && (
        <Typography variant='h1' sx={pdfH1} mb={3} ml={1} color={orangeColors[70]}>
          {pageSection}
        </Typography>
      )}
      <Box width={'500px'}>
        <Typography sx={bodyPdf} mb={1}>
          {replaceColon(t('shared.overlapText'))} <strong style={{display: 'none'}}>{totalOverlap}%</strong>
        </Typography>
      </Box>
    </Grid>
  );
};
